
  import Vue from 'vue';
  import {mapMutations, mapState} from 'vuex';
  import * as VuexMutation from '@/store/mutation-types';
  import * as util from '@/util';
  import {library} from '@/models/library';
  import {Video} from '@/models/youtube';
  import {Track} from '@/models/track';
  import Card from '@/models/card';
  import Message from '@/models/message';

  export default Vue.extend({
    name: 'Videos',
    components: {
      CardList: () => import ('@/components/CardList.vue'),
      TrackList: () => import ('@/components/TrackList.vue'),
    },
    data() {
      return {
        library: library,
        videos: [] as Video[],
        videoCards: [] as Card[],
        videoToTracks: new Map<string, Track[]>(),
        selectedVideo: null as Video | null,
      }
    },
    async created() {
      const videoIdToVideo = new Map(library.tracks.map(track => [track.video.id, track.video]));
      const videos = [...videoIdToVideo.values()];
      this.videoToTracks = new Map(videos.map(
        video => [video.id, library.tracks.filter(track => track.video.id === video.id)]
      ));
      await Promise.all(videos.map(video => video.fetchVideoInfo()));
      this.videos = videos;
      this.videoCards = util.sortByKey(
        this.videos,
        video => video.publishedAt,
      ).reverse().map(video => {
        const keywords: Set<string> = new Set();
        library.tracks.filter(
          track => track.video.id === video.id
        ).map(track => {
          keywords.add(track.title);
          keywords.add(track.artist);
          keywords.add(track.singer);
          track.tags.map(tag => keywords.add(tag));
        });
        return {
          id: video.id,
          title: video.getTitle() || '',
          subtitle: (video.getChannel() || {}).name  || '',
          thumbnailUrl: video.getThumbnailURL('hqdefault'),
          metadata: [...keywords].join('  '),
        }
      });
    },
    computed: {
      ...mapState(['searchQuery']),
    },
    methods: {
      ...mapMutations({
        addToQueue: VuexMutation.ADD_TO_QUEUE,
        setQueue: VuexMutation.SET_QUEUE,
        setPlayingTrack: VuexMutation.SET_PLAYING_TRACK,
        setPlayerRepeat: VuexMutation.SET_PLAYER_REPEAT,
        addMessage: VuexMutation.ADD_MESSAGE,
      }),
      onClick(videoCard: Card) {
        this.selectedVideo = this.videos.find(video => video.id == videoCard.id) || null;
      },
      getTracksByVideoId(videoId: string): Track[] {
        return library.tracks.filter(track => track.video.id === videoId);
      },
      addTracksToQueue() {
        if (!this.selectedVideo) {
          throw Error("no video selected");
        }
        const tracks = this.getTracksByVideoId(this.selectedVideo.id);
        tracks.map(track => this.addToQueue(track.clone()));
        this.addMessage(new Message('info', tracks.length + '曲をキューに追加しました'));
      },
      shuffleAndQueue() {
        if (!this.selectedVideo) {
          throw Error("no video selected");
        }
        const tracks = util.shuffle(this.getTracksByVideoId(this.selectedVideo.id));
        if (tracks.length > 0) {
          this.setPlayingTrack(tracks[0]);
          this.setQueue(tracks);
          this.addMessage(new Message('info', tracks.length + '曲をキューにセットしました'));
        }
      },
      queueAndRepeat() {
        if (!this.selectedVideo) {
          throw Error("no video selected");
        }
        const tracks = this.getTracksByVideoId(this.selectedVideo.id);
        if (tracks.length > 0) {
          this.setPlayingTrack(tracks[0]);
          this.setQueue(tracks);
          this.setPlayerRepeat('repeat');
          this.addMessage(new Message('info', tracks.length + '曲をキューにセットしました'));
        }
      }
    }
  });
